export const DASHBOARD_TEMPLATE_ELEMENT_TYPES = {
  Widget: 'widget',
  Text: 'text',
  Bitmap: 'bitmap',
  ActionButtons: 'actionButtons',
  PairwizeComparisonGallery: 'pairwizeComparisonGallery',
  Gallery: 'gallery',
  CategoriesGallery: 'categoriesGallery',
  Layout: 'layout',
  LayoutHorizontal: 'layoutHorizontal',
  LayoutVertical: 'layoutVertical',
  LayoutSequence: 'layoutSequence',
  Tabber: 'tabber',
} as const;

export type DashboardTemplateElementType =
  (typeof DASHBOARD_TEMPLATE_ELEMENT_TYPES)[keyof typeof DASHBOARD_TEMPLATE_ELEMENT_TYPES];
